import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Try to scroll to the hash element, with retries for lazy-loaded content
      const scrollToHash = () => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
          return true;
        }
        return false;
      };

      // Try immediately
      if (!scrollToHash()) {
        // Retry after delays to handle lazy loading
        const delays = [100, 300, 500, 1000];
        delays.forEach((delay) => {
          setTimeout(scrollToHash, delay);
        });
      }
    } else {
      // No hash, scroll to top
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
};
